module.exports = __webpack_public_path__ + "static/gallery4-cff603355dbca89777e0db62f12b5c69.jpg";